import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { ClientRequest, ClientResponse } from 'types/ClientTypes';

import { APIResponse, BUSMAN_TAGS, busmanApiSlice } from './busmanApiSlice';
import { getApiErrorMessage } from './errors';

export const clientEndpoints = busmanApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //Fetch all Clients
    getClients: builder.query({
      query: ({ isActive = 'true' }) => `/clients/?is_active=${isActive}`,
      providesTags: [BUSMAN_TAGS.Client],
      transformResponse: (response: APIResponse<ClientResponse[]>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    getClientById: builder.query({
      query: (id?: string | null) => `/clients/${id}`,
      providesTags: (_result, _err, id) => [{ type: BUSMAN_TAGS.Client, id: id ?? undefined }],
      transformResponse: (response: APIResponse<ClientResponse>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    createClient: builder.mutation({
      query: (newClient: ClientRequest) => ({
        url: '/clients/',
        method: 'post',
        body: newClient,
      }),
      invalidatesTags: [BUSMAN_TAGS.Client],
      transformResponse: (response) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    updateClientById: builder.mutation({
      query: (updateClient: ClientRequest) => ({
        url: `/clients/${updateClient.client_id}`,
        method: 'put',
        body: updateClient,
      }),
      transformResponse: (response) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
      invalidatesTags: (_result, _err, arg) => [BUSMAN_TAGS.Client, { type: BUSMAN_TAGS.Client, id: arg.client_id }],
    }),
  }),
});

export const { useGetClientsQuery, useGetClientByIdQuery, useCreateClientMutation, useUpdateClientByIdMutation } =
  clientEndpoints;
